import jspreadsheet from "jspreadsheet-ce";

const euroGerman = Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "EUR",
});


const selectCity = (config) => {
    return {
        // Methods
        closeEditor: function (cell, save) {
            var value = cell.children[0].value;
            cell.innerHTML = value;
            return value;
            // return cell.innerHTML;
        },
        openEditor: function (cell) {
            // cell.innerHTML = window.prompt('Huhu');
            const plz = parseInt(cell.previousSibling.innerHTML);
            const value = cell.innerHTML;
            cell.innerHTML = '';

            if (config.plzod.includes(plz)) {
                //Create array of options to be added
                const array = config.plzmap[plz];

                //Create and append select list
                const selectList = document.createElement("select");
                selectList.id = "mySelect";

                //Create and append the options
                for (var i = 0; i < array.length; i++) {
                    var option = document.createElement("option");
                    option.value = array[i].name;
                    option.text = array[i].name;
                    option.selected = array[i].name === value;
                    selectList.appendChild(option);
                }

                cell.appendChild(selectList);
            } else {
                const input = document.createElement("input");
                input.type = "text";
                input.value = value;

                cell.appendChild(input);
                input.focus();
            }
        },
        getValue: function (cell) {
            return cell.innerHTML;
        },
        setValue: function (cell, value) {
            cell.innerHTML = value;
        }
    }
}


export default class TripParticipantsTable {

    constructor(data, formField, element, config) {
        this.formField = formField;
        this.config = config;
        this.isdirty = false;
        this.submitting = false;
        this.table = jspreadsheet(element, {
            data: this.updateData(data),
            columns: [
                {type: 'text', title: 'Vorname + Name', width: 150, align: 'left'},
                {type: 'text', title: 'm/w/d', width: 80, autocomplete: true, source: ["m", "w", "d"]},
                {type: 'numeric', title: 'Alter', width: 80},
                {type: 'numeric', title: 'PLZ', width: 80, align: 'left'},
                {type: 'text', title: 'Stadt', width: 180, align: 'left', editor: selectCity(config)},
                {type: this.config.type === 'ibs' ? 'checkbox' : 'hidden', title: 'Ausland', width: 80},
                {type: 'text', title: '< 27', readonly: true, backgroundColor: '#eee'},
                {type: 'text', title: 'Stor', readonly: true},
                {type: 'text', title: 'Teiln', readonly: true},
                {type: 'text', title: 'Leit', readonly: true},
                {type: 'numeric', title: '€', readonly: true, mask: '#.##0,00', align: 'right'},
                {type: 'hidden', title: 'dis', readonly: true},
                {type: 'hidden', title: 'mun', readonly: true},
            ],
            allowInsertColumn: false,
            minSpareRows: 1,
            onchange: () => {
                const data = this.table.getData();
                this.isdirty = true;
                this.table.setData(this.updateData(data));
            },
            ondeleterow: () => {
                const data = this.table.getData();
                this.table.setData(this.updateData(data));
            },
            onundo: () => {
                const data = this.table.getData();
                this.table.setData(this.updateData(data));
            },
            // onselection: (table, a, b, c, d, o) => {
            //     console.log(table, a, b, c, d, o);
            // }
            onselection: function (instance, x1, y1, x2, y2, origin) {
                if (x1 === 4) {
                    var columnName = jspreadsheet.getColumnNameFromId([x1, y1]);
                    var cell = instance.jspreadsheet.getCell(columnName);
                    instance.jspreadsheet.openEditor(cell);
                    // cell.children[0].dropdown.close(true);
                }
            }
        });
        window.addEventListener("beforeunload", (e) => {
            console.log(this, this.submitting);
            if (this.submitting || !this.isdirty) {
                return undefined;
            }

            var confirmationMessage = 'Ängerungen gehen eventuell verloren.';

            (e || window.event).returnValue = confirmationMessage; //Gecko + IE
            return confirmationMessage; //Gecko + Webkit, Safari, Chrome etc.
        });
    }

    onSubmit() {
        this.submitting = true;
    }

    lookupFunding(name, days) {
        const municipalityData = this.config.municipalities[name];

        if (!municipalityData) {
            return 0;
        }

        if (days < 3) {
            return municipalityData.daytrips ? municipalityData.rate * days : 0;
        }

        return municipalityData.rate * days;
    }

    isOD(row) {
        // const maybeOD = this.config.plzod.includes(parseInt(row[3]));
        const plz = parseInt(row[3]);
        const municipalities = this.config.plzmap[plz];
        if (!municipalities)
            return false;
        let result = false;
        // console.log(row);
        municipalities.forEach(municipality => {
            if (municipality.name === row[4].trim() && municipality.od)
                result = true;
        })
        return result;
    }

    updateData(data, id = "Form_ParticipantListForm_Participants") {

        const days = parseInt(this.config.daysCount);
        const otherBenefits = parseInt(this.config.otherBenefits);
        const type = this.config.type;


        //Anzahl Jugendliche Stormarn
        const numOD = data.reduce((num, row) => {
            return (
                row[2] &&
                (row[2] < 27) &&
                row[0] !== this.config.lt &&
                this.isOD(row)
            ) ? num + 1 : num;
        }, 0)

        //Anzahl Jugendliche, not really correct
        const numYouth = data.reduce((num, row) => {
            return (
                row[2] &&
                (row[2] < 27) &&
                row[0] !== this.config.lt
            ) ? num + 1 : num;
        }, 0)

        //Anzahl Ausländer
        let numForeign = type === 'ibs' ? data.reduce((num, row) => {
            return (row[5]) ? num + 1 : num;
        }, 0) : 0;


        const maxLT = Math.ceil((this.config.calcLTwithNonOD ? numYouth : numOD) / 7);
        const maxNonOD = ~~(numOD / 2);

        const districtRate = this.config.districtRate;

        let numTN = 0;
        let numNonOD = 0;
        let numLT = 0;
        let numResident = 0;
        let sum = 0;
        let hasMainLT = data.reduce((result, row) => row[0] === this.config.lt ? true : result, false); // false;  // Has to be determined before?
        if (hasMainLT)
            numLT++;

        data.forEach((row, index) => {
            if (!(["", "m", "w", "d"].includes(row[1]))) {
                row[1] = ""; // Invalid value
            }

            if (!row[0] || !String(row[0]).trim() || !(row[3] || row[5])) {
                return; // Ignore empty
            }

            if (parseInt(row[2]) > 99) {
                row[2] = 0;
            }

            // <27
            const isYouth = (parseInt(row[2]) < 27);
            row[6] = isYouth ? 'X' : '';

            // OD
            const isOd = this.isOD(row);
            row[7] = isOd ? 'X' : '';

            const isNeighbour = isOd || this.config.plzother.includes(parseInt(row[3]))

            // TN
            let isTN = row[0] !== this.config.lt && isYouth && isNeighbour &&
                (isOd || (!isOd && (numNonOD < maxNonOD)));

            if (type === 'ibs') {
                if (row[5]) { // Ausländer
                    isTN = true;
                } else {
                    isTN = isTN && (numResident < numForeign); // Inländer limitieren
                    if (isTN) {
                        numResident++;
                    }
                }
            }
            row[8] = isTN ? 'X' : '';

            console.log (row);

            let isLT = false;

            if (isTN) {
                if (!isOd) numNonOD++;
                numTN++;
            } else {
                if (row[0] == this.config.lt) { // Hauptleiter
                    isLT = true;
                    hasMainLT = true;
                } else {
                    isLT = !isTN && (row[2] >= 16) && numLT < maxLT;
                    if (isLT)
                        numLT++;
                }
            }
            row[9] = isLT ? 'X' : '';

            let funding = 0
            if ((isTN || isLT) && !otherBenefits) { //Nur Gemeinde
                funding += districtRate * days;
                row[11] = districtRate * days;
            }

            row[12] = 0;
            if ((isTN || isLT) && isOd) {
                const municipalityFunding = this.lookupFunding(row[4].trim(), days)
                funding += municipalityFunding;
                row[12] = municipalityFunding;
            }

            //TODO: Barsbüttel

            row[10] = funding;
            sum += funding;

        })

        const summaryNode = document.getElementById('summary');

        let summary = "";
        // summary += 'Anzahl TN: ' + numTN + '<br/>';
        // summary += 'Außerhalb OD: ' + numNonOD + '<br/>';
        // summary += 'Max LT: ' + maxLT + '<br/>';
        // summary += 'Anzahl LT: ' + numLT + '<br/>';
        // summary += 'Förderung: ' + sum + '<br/>';

        summary = `<p>Bei Freizeitfahrten dürfen geförderte Teilnehmer*innen das 27. Lebensjahr noch nicht abgeschlossen haben und
        sie müssen aus den Kreisen Stormarn, Herzogtum Lauenburg oder Segeberg bzw. den Hansestädten Lübeck und Hamburg kommen. Das sind hier <strong>${numTN}</strong>, davon sind
        <strong>${numNonOD}</strong> nicht aus Stormarn (maximal ein Drittel der Teilnehmer*innen darf von außerhalb Stormarn kommen).</p>`;
        if (this.config.type === 'ibs')
            summary += `<p>Bei internationalen Begegnungen können maximal genauso viele Teilnehmer*innen aus dem Inland wie aus
            dem Ausland gefördert werden, hier also <strong>${numForeign}</strong>.</p>`;
        summary += `<p>Für alle sieben Teilnehmer*innen darf ein Leiter dabei sein, hier werden <strong>${numLT}</strong> Personen als Leiter
        gefördert.</p>`
        if(otherBenefits)
            summary += `<p>Es wird nur die Gemeindeförderung, nicht die Kreisförderung beantragt.</p>`
        summary += `<p>Die Gesamtfördersumme beträgt voraussichtlich (vorbehaltlich der Prüfung): <strong>${euroGerman.format(sum)}</strong></p>`
        if (!hasMainLT) {
            summary += `<p class="message error">Der/die auf Seite 3 angegebene Leiter*in fehlt in der Teilnehmerliste</p>`
        }
        if ((numTN - numNonOD) < 5) {
            summary += `<p class="message error">Es müssen mindestens fünf Stormarner Jugendliche teilnehmen</p>`
        }

        summaryNode.innerHTML = summary;
        this.formField.value = JSON.stringify(data);
        return data;
    }
}
